import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createLeader = ({
  churchId,
  leaderData,
  isDenominationChurch = false
}) => {
  if (isDenominationChurch) {
    return axios.post(`/denomination-churches/${churchId}/leaders`, leaderData);
  }

  return axios.post(`/churches/${churchId}/leaders`, leaderData);
};

export const useCreateLeader = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("leaders");
      setNotification({
        type: "success",
        message: "Leader created successfully!"
      });
    },
    ...config,
    mutationFn: createLeader
  });
};
